module.exports = __webpack_public_path__ + "img/Batterie.f9bc6a04.png";